module.exports = __webpack_public_path__ + "static/img/logo-truemoneywallet-300x300-1.001efdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-truemoneywallet-300x300-1.jpg
// module id = csSB
// module chunks = 3